// default whid
export const defWidth = 1920;
//LANGUAGES
export const LANG_TYPE = "langs";
export const LANG_TYPEA = "langA";
export const LANG_KOR = "KOR";
export const LANG_ENG = "ENG";
export const LANG_JNP = "JNP";
// url 정보
export const ITEMS = "items";
export const DEPTH1 = "depth1";
export const DEPTH2 = "depth2";
//메뉴
export const URL_SEI = "/";
export const URL_MAIN = "/main";
/** user */
// 회사소개
export const URL_COMPANY = "/company";
export const URL_HISTORY = "/history";
export const URL_GOALS = "/goals";
export const URL_REGISTRATION = "/registration";
export const URL_LOCATION = "/location";
//ESG
export const URL_2023ESG = "/2023esg";
export const URL_2024ESG = "/2024esg";
export const URL_2025ESG = "/2025esg";
// 전체제품
export const URL_PRODUCTS = "/products";
export const URL_NWENC = "/nwenc";
export const URL_NFZ = "/nfz";
// 고객샌터
export const URL_NOTICE = "/notice";
export const URL_FAQ = "/faq";
export const URL_CONTACT = "/contact";
//안전관리
export const URL_SAFETY = "/safety";
//보안 관리
export const URL_SECURITY = "/security";
// 상세,수정,작성
export const URL_DETAIL = "detail";
export const URL_UPDATE = "update";
export const URL_WRITE = "write";
/**  */
/** admin */
export const URL_LOGIN = "/login";
export const TOKEN = "token";
export const URL_ADMIN = "/admin";
export const URL_PRODUCTSMANAGEMENT = "/productsmanagement";
export const URL_BOARDMANAGEMENT = "/boardmanagement";
/**  */
export const URL_NOT_FOUND = "/notfound";
export const URL_SYSTEM_ERROR = "/systemerror";
export const POPID = "popup";
export const AD_M = "menu";
export const AD_P = "product";
export const AD_B = "board";
//
export const TYPE_V = "view";
export const TYPE_C = "create";
export const TYPE_P = "update";
export const TYPE_L = "list";
//uuid
// export const URL_APPROVALMANAGEMENT = decode(
//   "/\\u0061\\u0070\\u0070\\u0072\\u006f\\u0076\\u0061\\u006c\\u006d\\u0061\\u006e\\u0061\\u0067\\u0065\\u006d\\u0065\\u006e\\u0074",
// );
export const API_GET = "GET";
export const API_POST = "POST";
export const API_POSTF = "POSTF";
export const API_PUT = "PUT";
export const API_DELETE = "DELETE";
//API RESULT
export const API_200 = 200; // HTTP 200
export const API_500 = 500; // HTTP 500
export const API_999 = 999; // HTTP 999
//APP FIELD DATA
export const FLD_AUTOFIELD = "autofield";
export const FLD_MSG_DELETE_COMMON = "요청하신 정보가 삭제되었습니다.";
export const ERROR_MSG = "요청하신 작업을 처리하는 데 문제가 발생했습니다.";
export const ERROR_SERVER_MSG = "현재 시스템 점검 중이거나 예상치 못한 오류가 발생했습니다.";
